<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ListDependenciesReadModel } from "@Alternatives/AlternativesViews/Domain/readmodels";
    import { dynamicUiRoutes } from "@common/dynamicUiRoutes";
    import { DependentEntityInfo } from "@common/types";


    @Component({
        props: {
            initialized: {
                type: Boolean,
                default: false,
                required: true
            },
            reports: {
                type: Array,
                required: true
            },
            lists: {
                type: Array,
                required: true
            },
            estimationsSurveys: {
                type: Array,
                required: true
            },
        }
    })
    export default class AlternativesViewDependenciesList extends Vue
    {
        url_ReportViewPage(e: DependentEntityInfo): string
        {
            return dynamicUiRoutes.Reports_ReportViewPage(this.$route, e.WorkspaceId, e.TchProjectId, e.Id);
        }  
    }

</script>

<template>
    <div>
        <h4 v-if="!initialized">
            <i class="fa fa-spinner fa-spin"></i> Checking dependencies...
        </h4>
        <div v-if="initialized">
            <div class="card mt-3" v-if="reports.length > 0">
                <div class="card-header">
                    Reports ({{reports.length}})
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="r in reports" :key="r.Id">
                        <a class="text-primary" target="_blank" v-sanitizedHref="url_ReportViewPage(r)">{{r.Name}}</a>
                    </li>
                </ul>
            </div>

            <div class="card mt-3" v-if="lists.length > 0">
                <div class="card-header">
                    Lists ({{lists.length}})
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="l in lists" :key="l.Id">
                        <span>{{l.Name}}</span>
                    </li>
                </ul>
            </div>

            <div class="card mt-3" v-if="estimationsSurveys.length > 0">
                <div class="card-header">
                    Assessments ({{estimationsSurveys.length}})
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="s in estimationsSurveys" :key="s.Id">
                        <span>{{s.Name}}</span>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>